import { Radio } from "@headlessui/react";

import type { BookingProvider } from "~/services/admin/types";
import { Chip, icons } from "~/ui";
import { tw } from "~/utils";

const ProviderAvatar = ({ provider }: { provider: BookingProvider }) => (
  <div className="size-9 shrink-0 overflow-hidden rounded-full">
    {provider.imageUrl ? (
      <img src={provider.imageUrl} alt="" className="size-full object-cover" />
    ) : (
      <div className="text-violet flex size-full items-center justify-center bg-violet-100">
        <span className="text-sm font-semibold">{provider.name.charAt(0)}</span>
      </div>
    )}
  </div>
);

const ProviderOptionContent = ({ provider }: { provider: BookingProvider }) => (
  <div className="flex min-w-0 items-center gap-3">
    <ProviderAvatar provider={provider} />
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-indigo text-sm font-medium">
        {provider.name}, {provider.title}
      </span>
      {provider.isMostRecent && (
        <Chip type="violet" size="sm">
          Most recent provider
        </Chip>
      )}
      {provider.availableToday && (
        <Chip type="blue" size="sm">
          Available today
        </Chip>
      )}
    </div>
  </div>
);

export const ProviderOption = ({ provider }: { provider: BookingProvider }) => {
  if (!provider.inNetwork) {
    return (
      <Radio
        as="div"
        value={provider.id}
        disabled
        className="flex w-full items-center rounded-lg bg-gray-50 p-3 opacity-80"
      >
        <ProviderOptionContent provider={provider} />
        <span className="sr-only">Out of network, not selectable</span>
      </Radio>
    );
  }

  return (
    <Radio
      as="div"
      value={provider.id}
      className={({ checked }) =>
        tw(
          "flex w-full items-center justify-between gap-3 rounded-lg border bg-gray-50 p-3 text-left transition-colors hover:bg-gray-100",
          checked ? "border-violet bg-placebo-lavender" : "border-transparent",
        )
      }
    >
      <ProviderOptionContent provider={provider} />
      <icons.outline.ChevronRightIcon
        aria-hidden="true"
        className="text-indigo stroke-3 size-5 shrink-0"
      />
    </Radio>
  );
};
